import { Box, Container, Stack, Typography } from '@mui/material';
import Page from 'components/Page';
import React from 'react';
import { useLocation, useParams } from 'react-router';
import { ChallengeForm } from './ChallengeForm/ChallnegeForm';

export function NewChallenge() {
  const location = useLocation();
  const param = useParams();

  return (
    <Container style={{ maxWidth: '1200px' }}>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        mb={5}
      >
        <Typography variant='h4' gutterBottom>
          루틴 정보 입력
        </Typography>
      </Stack>
      <ChallengeForm
        challengeId={param.id}
        mode={location.pathname.includes('modify') ? 'modify' : 'new'}
      />
    </Container>
  );
}
